import { FC, useEffect, useState } from "react";
import BreadCrumbs from "../../../components/common/BreadCrumbs/BreadCrumbs";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ScrollToTopBtn from "../../../components/common/ScrollToTopBtn";
import Notifications from "../../../components/common/Notifications";
import Tabs from "../../../components/common/Tabs";
import { tuitionManagerViewDetailsTabsData } from "../../../config/tabsConfig";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { fetchApplicationAllDetails } from "../../../store/slices/Tuition/tuitionManagerPortalSlice";
import Loader from "../../../components/common/Loader";

import { trackNavigation } from '../../../services/analytics';


const TuitionManagerDetails: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const empNuid = location.state?.empNuid || "";
  const [showErrorNotification, setShowErrorNotification] = useState(false);

  const applicationDetails = useAppSelector(
    (state: any) => state?.tuitionManagerPortal?.applicationDetails
  );
  const { data = {}, loading = false, error = null } = applicationDetails || {};

  useEffect(() => {
    if (id && empNuid) {
      dispatch(
        fetchApplicationAllDetails({
          applicationId: id,
          empNuid: empNuid,
        }) as any
      );
    }
  }, [id, empNuid, dispatch]);

  // Show error notification when error occurs
  useEffect(() => {
    if (error) {
      setShowErrorNotification(true);
    
    }
  }, [error]);

  const handleBreadcrumbPrevious = (): void => {
    console.log('📊 Analytics: Navigate back to manager portal');
    trackNavigation('tuition-manager-details', 'tuition-manager-portal', 'back');
    navigate("/tuition/manager-portal");
  };

  if (loading) {
    return (
      <div className="min-h-screen desktop:mx-40! mx-5! flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen desktop:mx-40! mx-5! flex flex-col">
        <BreadCrumbs
          previousPage="Back to manager portal"
          currentPage={`Application ${id}`}
          onPreviousClick={handleBreadcrumbPrevious}
        />
        {showErrorNotification && (
          <div className="flex  items-center justify-center h-[65vh]">
            <div className="w-full max-w-md">
              <Notifications messageInfo={error} status={false} />
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="min-h-screen desktop:mx-40! mx-5!">
      <BreadCrumbs
        previousPage="Back to manager portal"
        currentPage={`Application ${id}`}
        onPreviousClick={handleBreadcrumbPrevious}
      />
      <div>
        <h1 className="h1  pl-3! mt-8!">View details</h1>
      </div>
      <Tabs 
        tabs={tuitionManagerViewDetailsTabsData} 
        extraProps={{ applicationData: data }}
      />
      <ScrollToTopBtn />
    </div>
  );
};

export default TuitionManagerDetails;
